import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
class ProductComparisonAPI {
    constructor() {
        this.getCompareFeatures = (listProducts, servicesEndpoint, defaultRequestParams, locale) => __awaiter(this, void 0, void 0, function* () {
            const requestData = listProducts.map(item => {
                return {
                    productCode: item.productCode,
                    productId: item.productId,
                    colourId: item.colourId,
                };
            });
            const axiosConfig = {
                data: requestData,
                method: 'POST',
                params: Object.assign(Object.assign({}, defaultRequestParams), { locale }),
                url: `${servicesEndpoint}api/search/lister/${defaultRequestParams.market}/search/compare`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new ProductComparisonAPI();
